import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import Accordion from '@components/accordian/Accordion'

interface IProps {
  children: ReactNode
  id: number
  handleOpen?: any
}

const Collapsed = ({ children, handleOpen, id }: IProps) => (
  <Header className={'acHeader'} role='button' onClick={handleOpen} data-id={id}>
    {children}
  </Header>
)

const Header = styled(motion.div)`
  //color: #007bff; // blue
  //background: rgba(0, 0, 0, 0.075); // gray
  //padding: 15px 15px;
`

export default Collapsed
